// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"32c1b264","453":"8e1f8322","732":"5fc70db9","977":"26b11933"}[chunkId] + ".chunk.js";
};